import getThemeMerger from 'util/getThemeMerger'

export default getThemeMerger((currentTheme) => ({
  overrides: {
    MuiTypography: {
      h1: {
        fontSize: '1.7em',
        lineHeight: 1.35,
        fontWeight: 400,
        color: currentTheme.palette.primary.main,
        textAlign: 'right',
      },
    },
    MuiTabs: {
      root: {
        borderBottom: `1px solid ${currentTheme.palette.dashboard.card2}`,
        borderTop: `1px solid ${currentTheme.palette.dashboard.card2}`,
        maxHeight: '5em',
      },
      flexContainer: {
        '& .Mui-disabled:nth-child(5)': {
          borderLeft: `1px solid ${currentTheme.palette.dashboard.card2}`,
        },
      },
    },
    MuiTab: {
      textColorInherit: {
        opacity: 1,
        color: currentTheme.palette.tertiary.lightGrey,
        '&.Mui-selected': {
          color: currentTheme.palette.tertiary.darkGreen,
        },
        '&.Mui-disabled': {
          opacity: 1,
          background: currentTheme.palette.background.main,
          color: currentTheme.palette.text.disabled,
        },
      },
    },
  },
}))
